import { LightningElement, api, track, wire } from "lwc";
import { c as classNames } from "tds/chunk_index";
import { LabelsAdapter } from "common/labelsAdapter";
import { getCurrentInteractionMethod } from "common/interactionMethodObserver";
import { getNextFocusIndex } from "common/a11y";
import { DEFAULT_SPRITE } from "tds/icon";
import { attrToBool, flattenOptions } from "common/helpers";
import { pointsForRect } from "common/geometry";

var data$9 = {
  aria_set:
    "%{current_index} von %{total_option_count}. %{visible_option_count} Ergebnisse verfügbar.",
  aria_option_deselected: "Auswahl von Option %{label} aufgehoben.",
  aria_option_focused: "Option %{label} in Fokus gerückt.",
  aria_option_selected: "Option %{label} ausgewählt.",
  no_matches: "Keine Übereinstimmungen gefunden.",
  placeholder: "Auswählen...",
  selected: "%{count} ausgewählt",
};
data$9.aria_set;
data$9.aria_option_deselected;
data$9.aria_option_focused;
data$9.aria_option_selected;
data$9.no_matches;
data$9.placeholder;
data$9.selected;

var data$8 = {
  aria_set:
    "%{current_index} of %{total_option_count}. %{visible_option_count} results available.",
  aria_option_deselected: "Option %{label} deselected.",
  aria_option_focused: "Option %{label} focused.",
  aria_option_selected: "Option %{label} selected.",
  no_matches: "No matches found.",
  placeholder: "Select...",
  selected: "%{count} selected",
};
data$8.aria_set;
data$8.aria_option_deselected;
data$8.aria_option_focused;
data$8.aria_option_selected;
data$8.no_matches;
data$8.placeholder;
data$8.selected;

var data$7 = {
  aria_set:
    "%{current_index} de %{total_option_count}. %{visible_option_count} resultados disponibles.",
  aria_option_deselected: "Opción %{label} no seleccionada.",
  aria_option_focused: "Opción %{label} destacada.",
  aria_option_selected: "Opción %{label} seleccionada.",
  no_matches: "No se encontraron coincidencias.",
  placeholder: "Seleccionar...",
  selected: "%{count} seleccionado",
};
data$7.aria_set;
data$7.aria_option_deselected;
data$7.aria_option_focused;
data$7.aria_option_selected;
data$7.no_matches;
data$7.placeholder;
data$7.selected;

var data$6 = {
  aria_set:
    "%{current_index} de %{total_option_count}. %{visible_option_count} resultados disponibles.",
  aria_option_deselected: "Opción %{label} no seleccionada.",
  aria_option_focused: "Opción %{label} destacada.",
  aria_option_selected: "Opción %{label} seleccionada.",
  no_matches: "No se encontraron coincidencias.",
  placeholder: "Seleccionar...",
  selected: "%{count} seleccionado",
};
data$6.aria_set;
data$6.aria_option_deselected;
data$6.aria_option_focused;
data$6.aria_option_selected;
data$6.no_matches;
data$6.placeholder;
data$6.selected;

var data$5 = {
  aria_set:
    "%{current_index} sur %{total_option_count}. %{visible_option_count} résultats disponibles.",
  aria_option_deselected: "Option %{label} désélectionnée.",
  aria_option_focused: "Option %{label} prioritaire.",
  aria_option_selected: "Option %{label} sélectionnée.",
  no_matches: "Aucun résultat trouvé.",
  placeholder: "Sélectionnez...",
  selected: "%{count} sélectionné(s)",
};
data$5.aria_set;
data$5.aria_option_deselected;
data$5.aria_option_focused;
data$5.aria_option_selected;
data$5.no_matches;
data$5.placeholder;
data$5.selected;

var data$4 = {
  aria_set:
    "%{current_index} di %{total_option_count}. %{visible_option_count} risultati disponibili.",
  aria_option_deselected: "Opzione %{label} deselezionata.",
  aria_option_focused: "Opzione %{label} in evidenza.",
  aria_option_selected: "Opzione %{label} selezionata.",
  no_matches: "Nessuna corrispondenza trovata.",
  placeholder: "Seleziona...",
  selected: "%{count} selezionati",
};
data$4.aria_set;
data$4.aria_option_deselected;
data$4.aria_option_focused;
data$4.aria_option_selected;
data$4.no_matches;
data$4.placeholder;
data$4.selected;

var data$3 = {
  aria_set:
    "%{current_index} / %{total_option_count}。%{visible_option_count} 件の結果があります。",
  aria_option_deselected: "オプション %{label} はオフです。",
  aria_option_focused: "オプション %{label} にフォーカスがあります。",
  aria_option_selected: "オプション %{label} はオンです。",
  no_matches: "一致は見つかりませんでした。",
  placeholder: "選択...",
  selected: "%{count} 件が選択されています",
};
data$3.aria_set;
data$3.aria_option_deselected;
data$3.aria_option_focused;
data$3.aria_option_selected;
data$3.no_matches;
data$3.placeholder;
data$3.selected;

var data$2 = {
  aria_set:
    "%{current_index}/%{total_option_count} %{visible_option_count}개 결과가 제공됩니다.",
  aria_option_deselected: "%{label} 옵션이 선택 취소되었습니다.",
  aria_option_focused: "%{label} 옵션을 구체적으로 검색합니다.",
  aria_option_selected: "%{label} 옵션이 선택되었습니다.",
  no_matches: "일치하는 항목이 없습니다.",
  placeholder: "선택...",
  selected: "%{count}개 선택됨",
};
data$2.aria_set;
data$2.aria_option_deselected;
data$2.aria_option_focused;
data$2.aria_option_selected;
data$2.no_matches;
data$2.placeholder;
data$2.selected;

var data$1 = {
  aria_set:
    "%{current_index} de %{total_option_count}. %{visible_option_count} resultados disponíveis.",
  aria_option_deselected: "Opção %{label} desmarcada.",
  aria_option_focused: "Opção %{label} destacada.",
  aria_option_selected: "Opção %{label} selecionada.",
  no_matches: "Nenhuma correspondência encontrada.",
  placeholder: "Selecionar...",
  selected: "%{count} selecionado(s)",
};
data$1.aria_set;
data$1.aria_option_deselected;
data$1.aria_option_focused;
data$1.aria_option_selected;
data$1.no_matches;
data$1.placeholder;
data$1.selected;

var data = {
  aria_set:
    "%{current_index}，共 %{total_option_count}。有 %{visible_option_count} 个结果。",
  aria_option_deselected: "已取消选择 %{label} 选项。",
  aria_option_focused: "已关注 %{label} 选项。",
  aria_option_selected: "已选择 %{label} 选项。",
  no_matches: "找不到匹配目标。",
  placeholder: "选择...",
  selected: "已选择 %{count} 个",
};
data.aria_set;
data.aria_option_deselected;
data.aria_option_focused;
data.aria_option_selected;
data.no_matches;
data.placeholder;
data.selected;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

// Remove whitespace from a string for autocomplete matching
const trimString = (str) => str.replace(/\s|\n/g, "");

class combobox extends LightningElement {
  @api variant = "base";
  @api label = null;
  @api placeholder = null;
  @api busy = false;
  @api toggleDisabled = false;
  @api ariaLabel = null;
  @api disabled = false;
  @api required = null;
  @api errorMessage = null;
  @track selection = [];
  @track _options = [];

  @api get options() {
    return this.toOptions(this._options);
  }

  set options(newValue) {
    this._options = newValue;
  }

  @api get value() {
    if (!this.selection.length) return "";
    return this.multiple ? this.selection : this.selection[0];
  }

  set value(newValue) {
    // Add new value to selection set
    if (newValue == null) {
      this.selection = [];
    } else {
      this.selection = [].concat(newValue);
    }
  }

  _multiple = false;

  @api get multiple() {
    return this._multiple;
  }

  set multiple(newValue) {
    this._multiple = attrToBool(newValue);
  }

  @api focus() {
    this.template.querySelector("input")?.focus();
  }

  @wire(LabelsAdapter, {
    locales,
    options: "$labelOptions",
  })
  labels = null;

  get controlClass() {
    return classNames("control", {
      "control--disabled": this.isDisabled,
      "combobox--errored": this.hasError,
    });
  }

  get isDisabled() {
    return attrToBool(this.disabled);
  }

  get labelClasses() {
    return classNames({
      "label--required": this.isRequired,
    });
  }

  get isRequired() {
    return attrToBool(this.required);
  }

  get labelOptions() {
    const activeOption = this.visibleOptions[this.focusedIndex] || {
      label: "",
    };
    return {
      aria_set: {
        current_index: this.focusedIndex + 1,
        total_option_count: this.flatOptions.length,
        visible_option_count: this.visibleOptions.length,
      },
      aria_option_deselected: {
        label: activeOption.label,
      },
      aria_option_focused: {
        label: activeOption.label,
      },
      aria_option_selected: {
        label: activeOption.label,
      },
      selected: {
        count: this.selection.length,
      },
    };
  }

  connectedCallback() {
    document.addEventListener("click", this.handleDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleDocumentClick);
  }

  lastEventType = null;
  inputValue = "";
  isOpen = false;
  hasFocus = false;
  focusedValue = null;
  _focusedIndex = 0;
  openTop = false;

  get inputIcon() {
    const option = this.options.find((o) => o.value === this.value);
    return option && option.icon;
  }

  get focusedIndex() {
    return this._focusedIndex;
  }

  set focusedIndex(newValue) {
    this._focusedIndex = newValue;
    this.lastEventType = "focus";

    if (this.visibleOptions.length) {
      this.focusedValue = this.visibleOptions[newValue].value;
    }
  }

  get focusedElementId() {
    if (this.template.querySelector(".option--focused")) {
      return this.visibleOptions[this.focusedIndex]?.value ?? null;
    } else {
      return null;
    }
  }

  get visibleOptions() {
    return this.flatOptions.filter((o) => !o.hidden);
  }

  get flatOptions() {
    return flattenOptions(this.options);
  }

  get flatOptionInits() {
    return flattenOptions(this._options);
  }

  get className() {
    return classNames("combobox", `combobox--${this.variant}`, {
      "combobox--disabled": this.isDisabled,
      "combobox--null": !this.value,
      "combobox--focused": this.hasFocus,
    });
  }

  get isBusy() {
    return attrToBool(this.busy);
  }

  get isToggleable() {
    return !attrToBool(this.toggleDisabled);
  }

  get isInputReadOnly() {
    return ["readonly", "accordion"].includes(this.variant);
  } // https://bugs.chromium.org/p/chromium/issues/detail?id=914451
  // https://bugs.chromium.org/p/chromium/issues/detail?id=587466
  // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion#preventing_autofilling_with_autocompletenew-password

  get autoCompleteAttribute() {
    return "off";
  }

  get ariaAutoCompleteAttribute() {
    return !this.isInputReadOnly ? "list" : null;
  }

  get inputStyle() {
    return this.isOpen || (this.hasFocus && !this.value)
      ? "z-index: 1;"
      : "z-index: 0;";
  }

  get displayValue() {
    if (!this.value) {
      return this.placeholder || this.labels.placeholder;
    }

    if (this.multiple) {
      return this.labels.selected;
    }

    const option = this.flatOptions.find((o) => o.value == this.value);
    return option ? option.label : this.placeholder || this.labels.placeholder;
  }

  get hasNoMatches() {
    return this.inputValue && !this.visibleOptions.length;
  }

  get shouldDeferClose() {
    return this.variant === "accordion";
  }

  get controlTabIndex() {
    return this.isInputReadOnly ? "0" : "-1";
  }

  get ariaLiveMessage() {
    switch (this.lastEventType) {
      case "focus":
        return `${this.labels.aria_option_focused} ${this.labels.aria_set}`;

      case "select":
        return `${this.labels.aria_option_selected} ${this.labels.aria_set}`;

      case "deselect":
        return `${this.labels.aria_option_deselected} ${this.labels.aria_set}`;

      case "input":
        return !this.visibleOptions.length
          ? this.labels.no_matches
          : this.displayValue;

      default:
        return this.displayValue || null;
    }
  }

  get ariaLabelledby() {
    return this.label ? "label" : null;
  }

  get listboxClass() {
    return classNames("listbox", {
      "listbox--top": this.openTop,
      "listbox--hidden": this.variant == "readonly",
    });
  }

  toOptions(optionInits) {
    return optionInits.map((o) => {
      const focused = o.value === this.focusedValue;
      const selected = this.selection.includes(o.value);
      const checkbox = this.multiple;

      const isHidden = (option) => {
        const input = trimString(this.inputValue.toLowerCase());
        const test = trimString((option.label || option.value).toLowerCase());
        return test.indexOf(input) === -1;
      };

      return {
        label: o.label,
        value: o.value,
        icon: o.icon && { ...o.icon, sprite: o.icon.sprite || DEFAULT_SPRITE },
        options: o.options ? this.toOptions(o.options) : undefined,
        className: classNames("option", {
          "option--focused": focused,
          "option--selected": selected,
          "option--checkbox": checkbox,
        }),
        focused,
        hidden: o.options ? o.options.every(isHidden) : isHidden(o),
        checkbox,
        selected,
        text: o.label,
        oncheckboxchange: () => {
          this.selectOption(o.value);
        },
        onclick: () => {
          // Get the target index from the current set of visible options
          this.focusedIndex = this.visibleOptions.findIndex(
            ({ value }) => value === o.value
          );
          this.selectOption(o.value);
        },
        onmouseover: () => {
          if (getCurrentInteractionMethod("control") === "mouse") {
            // Get the target index from the current set of visible options
            this.focusedIndex = this.visibleOptions.findIndex(
              ({ value }) => value === o.value
            );
          }
        },
      };
    });
  }

  focusInput() {
    const control = this.isInputReadOnly
      ? this.template.querySelector(".control")
      : this.template.querySelector("input");

    if (control) {
      control.focus();
    }
  }

  blurInput() {
    const input = this.template.querySelector("input");

    if (input) {
      input.blur();
    }
  }

  scrollOptionIntoView(index) {
    const options = this.template.querySelectorAll('[role="option"]');
    const option = options[index];
    if (!option) return;
    const listbox = this.template.querySelector('[role="listbox"]');
    const shouldScroll =
      option.offsetTop > listbox.clientHeight - option.clientHeight ||
      option.offsetTop < listbox.scrollTop - listbox.clientHeight;

    if (shouldScroll) {
      const { paddingTop, paddingBottom } = getComputedStyle(listbox);
      listbox.scrollTop =
        option.offsetTop -
        listbox.clientHeight +
        option.clientHeight +
        parseInt(paddingTop) +
        parseInt(paddingBottom);
    }
  }

  focusFirstOption() {
    const selected = this.selection[0]; // Focus the first selected option OR the first option if none are selected

    if (selected) {
      const selectedIndex = this.visibleOptions.findIndex(
        (o) => o.value === selected
      );
      this.focusedIndex = Math.max(selectedIndex, 0);
    } else {
      // Keep focus on current item unless it becomes hidden, then focus the very first item
      this.focusedIndex = Math.max(
        0,
        this.visibleOptions.findIndex((o) => o.value === this.focusedValue)
      );
    } // Scroll into view

    this.scrollOptionIntoView(this.focusedIndex);
  }

  openListBox() {
    if (this.isOpen || this.isDisabled) return;
    const rect = this.template.host.getBoundingClientRect();
    this.openTop = pointsForRect(rect).topLeft.isBottom;
    this.isOpen = true;

    if (this.visibleOptions.length) {
      this.focusFirstOption();
    }
  }

  closeListBox() {
    this.isOpen = false;
    this.inputValue = "";
    this.lastEventType = null;
  }

  selectOption(value) {
    const flatOptions = this.flatOptions;
    const option = flatOptions.find((o) => o.value === value);
    if (!option) return;

    if (this.selection.includes(option.value) && this.isToggleable) {
      this.selection = this.selection.filter((s) => s !== option.value);
      this.lastEventType = "deselect";
    } else {
      if (!this.multiple) {
        this.selection = [];
      }

      this.selection.push(option.value);
      this.lastEventType = "select";
    }

    this.value = this.selection;
    this.dispatchEvent(
      new CustomEvent("change", {
        detail: this.value,
      })
    );

    if (!this.shouldDeferClose && !this.multiple) {
      this.closeListBox();
    }
  }

  handleDocumentClick = (e) => {
    const isInsideClick = !!e
      .composedPath()
      .find((t) => t === this.template.host);

    if (!this.shouldDeferClose && !isInsideClick) {
      this.closeListBox();
    }
  };

  handleControlMouseDown(e) {
    e.preventDefault();

    if (!this.hasFocus && !this.isOpen) {
      this.focusInput();
      this.openListBox();
    } else if (!this.isOpen) {
      this.openListBox();
    } else {
      this.closeListBox();
    }
  }

  handleInputChange(e) {
    this.openListBox();
    this.inputValue = e.target.value;

    if (this.visibleOptions.length) {
      this.focusFirstOption();
    } else {
      this.lastEventType = "input";
    }
  }

  handleInputFocus() {
    this.hasFocus = true;
  }

  handleInputBlur() {
    this.hasFocus = false;

    if (!this.shouldDeferClose && !this.multiple) {
      this.closeListBox();
    }
  }

  handleListboxMouseDown(e) {
    // Only handle left-clicks
    if (e.button !== 0) return;
    e.stopPropagation();
    e.preventDefault();
    this.focusInput();
  }

  handleKeyDown(e) {
    switch (e.key) {
      case "Enter":
        e.preventDefault();

        if (!this.isOpen) {
          this.openListBox();
        } else {
          this.selectOption(this.visibleOptions[this.focusedIndex].value);
        }

        break;

      case " ":
        // Only handle spaces if the user hasn't started typing
        if (this.inputValue) break;
        e.preventDefault();

        if (!this.isOpen) {
          this.openListBox();
        } else if (!this.inputValue) {
          this.selectOption(this.visibleOptions[this.focusedIndex].value);
        }

        break;

      case "Escape":
        if (this.isOpen) {
          e.preventDefault();
          this.closeListBox();
        }

        break;

      case "ArrowUp": {
        e.preventDefault();
        this.focusedIndex = getNextFocusIndex(
          "prev",
          this.focusedIndex,
          this.visibleOptions.length
        ); // Scroll into view

        this.scrollOptionIntoView(this.focusedIndex);
        break;
      }

      case "ArrowDown": {
        e.preventDefault();

        if (!this.isOpen) {
          this.openListBox();
        } else {
          this.focusedIndex = getNextFocusIndex(
            "next",
            this.focusedIndex,
            this.visibleOptions.length
          );
        } // Scroll into view

        this.scrollOptionIntoView(this.focusedIndex);
        break;
      }
    }
  }

  get hasError() {
    return !!this.errorMessage;
  }
}

export default combobox;
